import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import moment from "moment";
import axios from "axios";

export const ConfigFechasQuin = (props) => {
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
  const [mes, setMes] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const txtAnio = useRef();
  const txtMes = useRef();
  const txtMesd = useRef();
  const txtFecha = useRef();
  const [fechasm, setFechasm] = useState();
  const [fechas, setFechas] = useState();
  const [values, setValues] = useState({
    anio: "",
    mes: "",
    fechaven: "",
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const onChange = (event) => {
    let anio = parseInt(fechaSistema.substring(9, 11));
    let dias = parseInt(fechaSistema.substring(1, 5));
    if (event.target.name === "mes") {
      const selectedIndex = event.target.options.selectedIndex;
      setFechas(selectedIndex);
      setFechasm(dias + "-" + selectedIndex + "-" + anio);
      let fc = selectedIndex;
      if (fc === 1) {
        txtMesd.current.value = "ENERO";
      } else if (fc === 2) {
        txtMesd.current.value = "FEBRERO";
      } else if (fc === 3) {
        txtMesd.current.value = "MARZO";
      } else if (fc === 4) {
        txtMesd.current.value = "ABRIL";
      } else if (fc === 5) {
        txtMesd.current.value = "MAYO";
      } else if (fc === 6) {
        txtMesd.current.value = "JUNIO";
      } else if (fc === 7) {
        txtMesd.current.value = "JULIO";
      } else if (fc === 8) {
        txtMesd.current.value = "AGOSTO";
      } else if (fc === 9) {
        txtMesd.current.value = "SEPTIEMBRE";
      } else if (fc === 10) {
        txtMesd.current.value = "OCTUBRE";
      } else if (fc === 11) {
        txtMesd.current.value = "NOVIEMBRE";
      } else if (fc === 12) {
        txtMesd.current.value = "DICIEMBRE";
      }
    }

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onFecha = () => {
    let mes;
    mes = parseInt(fechaSistema.substring(5, 7));
    setFechas(mes);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtAnio.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Año no debe ir Vacio",
        icono: "informacion",
      });
      txtAnio.current.focus();
      sigue = false;
    } else if (txtMes.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por Favor Seleccione el Mes",
        icono: "informacion",
      });
      txtMes.current.focus();
      sigue = false;
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por Favor Seleccione la Fecha de Vencimiento",
        icono: "informacion",
      });
      txtFecha.current.focus();
      sigue = false;
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarfechaproduc/${props.operacion}`;

    let body;
    setActivate(true);

    body = {
      nanio: txtAnio.current.value,
      nmes: txtMes.current.value,
      fecha: txtFecha.current.value,
      nomtabla: "fechavencimientoprodquin",
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setActivate(false);
    setMes();
    setValues({
      anio: "",
      mes: "",
      fechaven: "",
    });
    setOperacion(0);
    setFechasm();
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: ".", texto: "", icono: "" });
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  useEffect(() => {
    onFecha();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        btnAcepta.current.focus();
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.fechas[0]);
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {props.operacion === 1
              ? "Agregar Fechas de Vencimiento Quincenal de Mina."
              : props.operacion === 2
              ? "Editar Fechas de Vencimiento Quincenal de Mina."
              : props.operacion === 3
              ? "Eliminar Fechas de Vencimiento Quincenal de Mina."
              : "Consultar Fechas de Vencimiento Quincenal de Mina."}
          </h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div style={{ height: "auto", overflow: "auto" }}>
          <div>
            <div className="row rounded mx-auto">
              <div className="container rounded row d-flex border justify-content-between mx-auto col-md-12">
                <div className=" col-md-12 row py-3 px-4  ">
                  <div className="input-group input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee" }}
                      id="inputGroup-sizing-sm"
                    >
                      Año:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtAnio}
                      disabled={true}
                      name="anio"
                      value={
                        values
                          ? values.anio
                            ? values.anio
                            : anioActu
                          : anioActu
                      }
                    />
                    <select
                      disabled={
                        operacion === 2 || operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtMes}
                      className="form-control col-md-6 text-right"
                      id="inputStatus"
                      name="mes"
                      value={values.mes}
                      onChange={onChange}
                    >
                      <option value="">Mes</option>
                      <option value="1">01</option>
                      <option value="2">02</option>
                      <option value="3">03</option>
                      <option value="4">04</option>
                      <option value="5">05</option>
                      <option value="6">06</option>
                      <option value="7">07</option>
                      <option value="8">08</option>
                      <option value="9">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                  </div>

                  <div className="input-group input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee" }}
                      id="inputGroup-sizing-sm"
                    >
                      Mes:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtMesd}
                      disabled={true}
                      name="mesd"
                      defaultValue={props.mesf ? props.mesf : ""}
                      onChange={onChange}
                      id="inputFechaInscripcion"
                    />
                  </div>

                  <div className="input-group input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                      style={{ backgroundColor: "#55acee" }}
                    >
                      <i className="fas fa-calendar-alt fa-fw me-2"></i> Fecha
                      de Vencimiento:
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtFecha}
                      name="fechaven"
                      value={
                        values
                          ? values.fechaven
                            ? moment(values.fechaven).format("YYYY-MM-DD")
                            : moment(fechasm).format("YYYY-MM-DD")
                          : ""
                      }
                      onChange={onChange}
                      id="inputFechaInscripcion"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/minas/modalConfiFechaquin.js